/**
 * The task card's label maps, keyed by the effective type resolveEffectiveType produces.
 * Extracted from TaskCard.vue so the D24 coverage spec can walk them without mounting.
 */

/** CTA on a task the participant has not started. Falls back to a generic "View details". */
export const NEW_TASK_LABELS: Record<string, string> = {
    document_signing: 'Open document',
    complete_match_request: 'Verify identity',
    payment_emd: 'Make payment',
    payment_c2c: 'Make payment',
    payment_repayment: 'Resubmit payment',
    fraud_education: 'Watch video',
    send: 'Open instructions',
    collect: 'Provide bank details',
    confirm: 'Review bank details',
    payment_request_emd: 'Start payment',
    payment_request_c2c: 'Start payment',
};

/** CTA on a task already in progress, where "continue" reads better than the starting verb. */
export const IN_PROGRESS_LABELS: Record<string, string> = {
    send: 'View details',
    collect: 'Continue',
    confirm: 'Continue',
    fraud_education: 'View details',
};

/** Card title when the task carries none of its own. */
export const TASK_TYPE_TITLES: Record<string, string> = {
    fraud_education: 'Fraud Education',
    send: 'View wire instructions',
    collect: 'Submit bank details',
    confirm: 'Confirm bank details',
    match: 'Verify Identity',
    complete_match_request: 'Verify Identity',
    document_signing: 'Sign Documents',
    payment_emd: 'Make EMD Payment',
    payment_c2c: 'Make Payment',
    payment_repayment: 'Resubmit your payment to CertifID',
    payment_request: 'Request a Payment',
    // DS-3309 + purpose split (see resolveEffectiveType): a payment_request resolves
    // to a purpose-specific effective type for its card title.
    payment_request_emd: 'Send Earnest Money Deposit',
    payment_request_c2c: 'Send Cash to Close',
};

export const UNTITLED_TASK = 'Untitled Task';

/** D24 — "Untitled Task" reads like a backend problem, so name the type outside production. */
export function resolveTaskCardTitle(effectiveType: string): string {
    const title = TASK_TYPE_TITLES[effectiveType];
    if (title) return title;

    if (effectiveType && import.meta.env.DEV) {
        console.warn(`[TaskCard] No title for effective task type "${effectiveType}". Add it to TASK_TYPE_TITLES.`);
    }

    return UNTITLED_TASK;
}
